export default __webpack_public_path__ + "static/media/location.cd1fa2c0.svg";